import React from 'react';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { useToggleState } from '@hotelplan/libs.hooks-react';
import FdrMapAccessButton from 'fdr/components/local/fdr-map-access/fdr-map-access-button';
import FdrMapAccessLayout from 'fdr/components/local/fdr-map-access/fdr-map-access-layout';
import { FdrSrlMapModal } from 'fdr/components/local/fdr-srl-map/fdr-srl-map-modal';
import FdrWishlistMapForm from './fdr-wishlist-map-form';
import FdrWishlistMapPreview from './fdr-wishlist-map-preview';

const FdrWishlistMapAccess: React.FC<{ forceMapPreview?: boolean }> = ({
  forceMapPreview = false,
}) => {
  const { mobile } = useDeviceType();
  const [show, open, close] = useToggleState(false);

  return (
    <FdrMapAccessLayout>
      {mobile && !forceMapPreview ? (
        <FdrMapAccessButton onOpen={open} />
      ) : (
        <FdrWishlistMapPreview onOpen={open} />
      )}
      <FdrSrlMapModal show={show} onClose={close}>
        <FdrWishlistMapForm />
      </FdrSrlMapModal>
    </FdrMapAccessLayout>
  );
};

export default FdrWishlistMapAccess;
